// extracted by mini-css-extract-plugin
export default {"card":"VolunteeringCard_card__YYGyN","icon":"VolunteeringCard_icon__WOqIt","title":"VolunteeringCard_title__zLrCa"};